
import React, { useMemo } from 'react';
import { CustomButton } from '../../../components/customButton/CustomButton';
import { FormControl, Grid, InputAdornment, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import { DateInput } from '../../../components/dateInput/DateInput';

export const FiltersHeader = ({
    delegaciones,
    estado,
    estadoValidado,
    activeTabEnum,
    estadosOptions,
    filters,
    handleChange,
    handleChangeEstado,
    handleChangeFechaDesde,
    handleChangeFechaHasta,
    handleTextFilter,
    handleTextClean,
    handleSearch,
    handleChangeFilters
}) => {
    const condicionFechas = useMemo(() => {
        if (['CAMBIO_INDICACION', 'INGRESO_INDICACION', 'VALIDACION', 'CONFIRMAR_EQUIPO', 'CAMBIO_PROGRAMA'].includes(activeTabEnum) && estadosOptions?.some(option => option.id === estado && ['Realizado', 'Rechazado'].includes(option.displayName)))
            return true;

        if (activeTabEnum === 'ASIGNACION' && estadosOptions?.some(option => option.id === estado && option.displayName === 'Rechazado'))
            return true;

        return false;
    }, [activeTabEnum, estado, estadoValidado, estadosOptions]);

    return (
        <Grid
            container
            spacing={2}
            sx={{ marginBottom: '25px' }}
        >
            <Grid size={{ md: 2 }}>
                <FormControl sx={{ backgroundColor: 'white', width: '100%' }} size="small">
                    <InputLabel id="select-delegacion">Delegación</InputLabel>
                    <Select
                        labelId="select-delegacion"
                        label='Delegación'
                        onChange={handleChange}
                        value={filters?.idDelegacion}
                        name='idDelegacion'
                    >
                        {delegaciones && delegaciones.map((delegacion, index) => {
                            return <MenuItem key={delegacion.id ?? `delegacion-${index}`} value={delegacion.id}> {delegacion.displayName} </MenuItem>
                        })}
                    </Select>
                </FormControl>
            </Grid>
            <Grid size={{ md: 2 }}>
                <TextField
                    label="Buscador"
                    name="txtFiltro"
                    size="small"
                    type="text"
                    variant="outlined"
                    value={filters?.txtFiltro}
                    onChange={(e) => handleChangeFilters('txtFiltro', e.target.value)}
                    onKeyUp={handleTextFilter}
                    sx={{ backgroundColor: 'white' }}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <SearchIcon
                                    onClick={handleTextFilter}
                                    sx={{ cursor: 'pointer' }}
                                />
                                <ClearIcon
                                    onClick={handleTextClean}
                                    sx={{ cursor: 'pointer' }}
                                />
                            </InputAdornment>
                        ),
                    }}
                />
            </Grid>
            <Grid size={{ md: 2 }}>
                <FormControl sx={{ backgroundColor: 'white', width: '100%' }} size="small">
                    <InputLabel id="select-estado">Estado</InputLabel>
                    <Select
                        labelId="select-estado"
                        label='Estado'
                        onChange={handleChangeEstado}
                        value={estado}
                        name='estadoValidacion'
                    >
                        {estadosOptions && estadosOptions.map((estado, index) => {
                            return <MenuItem key={estado.id ?? `estado-${index}`} value={estado.id}> {estado.displayName} </MenuItem>
                        })}
                    </Select>
                </FormControl>
            </Grid>
            <Grid size={{ md: 2 }}>
                {
                    condicionFechas && <DateInput
                        label="Fecha Desde"
                        value={filters?.fechaDesde}
                        onChange={handleChangeFechaDesde}
                    />
                }
            </Grid>
            <Grid size={{ md: 2 }}>
                {
                    condicionFechas && <DateInput
                        label="Fecha Hasta"
                        value={filters?.fechaHasta}
                        onChange={handleChangeFechaHasta}
                    />
                }
            </Grid>
            <Grid sx={{ textAlign: 'right' }} size={{ md: 2 }}>
                <CustomButton
                    variant='contained'
                    onClick={handleSearch}
                    size='small'
                >
                    Buscar
                </CustomButton>
            </Grid>
        </Grid >
    )
}
